import { useState, useMemo } from "react";
import SettingsStore from "@/stores/SettingsStore";
import type { TAvatar } from "@/types/TAvatar";

export function useAvatarSelect() {
	const isLoading = SettingsStore((state) => state.isLoading);
	const avatars = SettingsStore((state) => state.avatars);
	const setAvatars = SettingsStore((state) => state.setAvatars);
	const [open, setOpen] = useState(false);

	const selectedAvatar = useMemo(() => {
		return avatars.find((avatar) => avatar.selected);
	}, [avatars]);

	const removeAvatar = (avatarId: string) => {
		const filtered = avatars.filter((avatar) => avatar.avatar_id !== avatarId);
		setAvatars(filtered);
	};

	const addAvatar = (avatar: TAvatar) => {
		// Ensure new avatars have a weight property
		const avatarWithWeight = {
			...avatar,
			weight: avatar.weight ?? 1.0
		};
		setAvatars([...avatars, avatarWithWeight]);
	};

	const updateAvatar = (avatar: TAvatar) => {
		setAvatars(
			avatars.map((a) => (a.avatar_id === avatar.avatar_id ? avatar : a)),
		);
	};

	const handleSelectAvatar = (avatar_id: string) => {
		const updatedAvatars = avatars.map(
			(avatar) => avatar.avatar_id === avatar_id ? { ...avatar, selected: true } : { ...avatar, selected: false },
		);
		setAvatars(updatedAvatars);
		setOpen(false);
	};

	return {
		isLoading,
		avatars,
		selectedAvatar,
		open,
		setOpen,
		removeAvatar,
		handleSelectAvatar,
		addAvatar,
		updateAvatar,
	};
}
